import { BaseEntity } from "./BaseEntity";

/**
 * Aplicacao da plataforma, no registry do liberty/auth.
 *
 * E o cadastro que faz uma aplicacao existir para o SSO: o menu lateral e
 * montado com o que `GET /apps` devolve, e o destino do ticket de sessao sai
 * das URLs registradas aqui -- nunca do link. Sem este cadastro, a plataforma
 * nao tem para onde mandar o usuario.
 *
 * O `slug` e o identificador estavel: e ele que vira a claim `aud` do token
 * emitido para a aplicacao. A API recusa troca de slug, e por isso o campo so
 * e editavel na criacao.
 */
export class ApplicationEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "components.settings.applications.application";
        this.pageTitle = "components.settings.applications.pageTitleList";
        this.menuPath = "/settings";
        this.APIRoute = "Resources/Settings/Applications";
        this.i18nBase = "components.settings.applications";
        this.baseEndPoint = "app";
        this.endpoints = {
            list: `${this.baseEndPoint}`,
            create: `${this.baseEndPoint}`,
            get: `${this.baseEndPoint}/:id`,
            delete: `${this.baseEndPoint}/:id`,
            urls: `${this.baseEndPoint}/:id/url`,
        };

        this.fields = [
            {
                key: "id",
                label: "user.fields.id",
                type: "text",
                visible: false,
                editable: false,
                orderBy: false,
            },
            {
                key: "slug",
                label: "components.settings.applications.slug",
                hint: "components.settings.applications.slugHint",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "slug",
            },
            {
                key: "label",
                label: "components.settings.applications.label",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "label",
            },
            {
                key: "icon",
                label: "components.settings.applications.icon",
                hint: "components.settings.applications.iconHint",
                type: "text",
                visible: true,
                required: false,
                editable: true,
                cols: 6,
                path: "icon",
            },
            {
                key: "sequence",
                label: "components.settings.applications.sequence",
                type: "number",
                visible: true,
                required: false,
                editable: true,
                cols: 6,
                path: "sequence",
            },
            {
                // Quem tem permissao neste servico enxerga a aplicacao no menu.
                // Vazio deixa a aplicacao visivel a qualquer usuario autenticado.
                key: "service_id",
                label: "components.settings.applications.service",
                hint: "components.settings.applications.serviceHint",
                type: "autocomplete",
                visible: true,
                required: false,
                editable: true,
                cols: 6,
                source: "serviceList",
                searchHandler: "handleServiceList",
                options: [],
                path: "service_id",
            },
            {
                key: "appmenu_catalog",
                label: "components.settings.applications.catalog",
                hint: "components.settings.applications.catalogHint",
                type: "text",
                visible: true,
                required: false,
                editable: true,
                cols: 6,
                path: "appmenu_catalog",
            },
            // `visible_in_menu` nao esta aqui de proposito: o Form.vue nao tem
            // tipo de switch generico, e o buildPayloadFromEntity so converte
            // para booleano os campos `activeSwitch` -- qualquer outro vira a
            // string "true", que a API recusa (`boolean` aceita true/1/"1",
            // nao "true"). O controle fica na propria pagina.
            {
                key: "status",
                label: null,
                type: "activeSwitch",
                visible: true,
                required: true,
                editable: true,
                orderBy: false,
                cols: 12,
                path: "status",
            },
        ];

        this.customActions = {
            duplicate: false,
        };

        this.tableColumns = [
            {
                key: "slug",
                label: "components.settings.applications.slug",
                visible: true,
                orderBy: true,
            },
            {
                key: "label",
                label: "components.settings.applications.label",
                visible: true,
                orderBy: true,
            },
            {
                key: "status",
                label: "common.labels.status",
                visible: true,
                orderBy: true,
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false,
            },
        ];

        this.pages = {
            edit: {
                pageTitle: `${this.i18nBase}.pageTitleEdit`,
                pathI18n: `components.settings.permissionManagement.menuList.Settings`,
                route: ["/settings", "/settings/applications", "/settings/applications/edit/:id"],
            },
            create: {
                pageTitle: `${this.i18nBase}.pageTitleCreate`,
                pathI18n: `components.settings.permissionManagement.menuList.Settings`,
                route: ["/settings", "/settings/applications", "/settings/applications/create"],
            },
            list: {
                pageTitle: `${this.i18nBase}.pageTitleList`,
                pathI18n: `components.settings.permissionManagement.menuList.Settings`,
                route: ["/settings", "/settings/applications"],
                filters: {
                    quickSearch: {
                        info: "components.settings.applications.searchBySlug",
                        searchBy: ["slug"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "status",
                                label: "common.labels.status",
                                type: "select",
                                options: [
                                    { label: "common.labels.active", value: true },
                                    { label: "common.labels.inactive", value: false },
                                ],
                                path: "status",
                            },
                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
